import { render, staticRenderFns } from "./TalentContract.vue?vue&type=template&id=e1f6d468&scoped=true"
import script from "./TalentContract.vue?vue&type=script&lang=js"
export * from "./TalentContract.vue?vue&type=script&lang=js"
import style0 from "./TalentContract.vue?vue&type=style&index=0&id=e1f6d468&prod&lang=scss&scoped=true"
import style1 from "./TalentContract.vue?vue&type=style&index=1&id=e1f6d468&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f6d468",
  null
  
)

export default component.exports